import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionAutoRenewAPICall extends APICallV3Post {
    _method = 'billing/subscription/autorenew';
}
